import { commentTextValidation, USER_ERR_MESSAGES } from "@bakbak/common";
import { CreateCommentMutation_createComment } from "@bakbak/controller";
import { Button, Form } from "antd";
import { Field, Form as FForm, FormikProps, withFormik } from "formik";
import * as React from "react";
import { THEME_COLOR } from "../../../constants";
import { InputField } from "../../../util/InputField";
import { loginRegisterAlert } from "../../shared/LoginRegisterAlert";

const FormItem = Form.Item;

interface FormValues {
  text: string;
}

interface Props {
  // onComplete: () => void;
  loggedUser: any
  postId: string;
  submit: (
    values: FormValues & { postId: string },
    loggedUser: any,
  ) => Promise<CreateCommentMutation_createComment | null>;
}

class CreateCommentForm extends React.PureComponent<FormikProps<FormValues> & Props> {
  submitCreateComment = (e: any) => {
    e.preventDefault();
    if (this.props.loggedUser) {
      this.props.handleSubmit();
    } else {
      loginRegisterAlert();
    }
  }
  renderButtons = () => (
    <div style={{ marginRight: 10, display: 'flex', justifyContent: 'flex-end' }}>
      <FormItem>
        CANCEL
        <Button htmlType="submit" style={{
          marginLeft: 20, color: "white", backgroundColor: THEME_COLOR, borderColor: THEME_COLOR
        }}>
          SUBMIT
        </Button>
      </FormItem>
    </div>
  )
  render() {
    return (
      <FForm style={{ width: '70%', marginTop: 20 }}>
        <div style={{ borderBottomWidth: 1, marginLeft: 50 }}>
          <Field
            name="text"
            placeholder="comment goes here"
            component={InputField}
            multiLine={true}
            minRows={2}
            maxRows={5}
            style={{ borderWidth: 0, borderBottomWidth: 1 }}
          />
        </div>
        {this.props.values.text.length > 0 && this.renderButtons()}
      </FForm>
    );
  }
}

export const CreateCommentView = withFormik<Props, FormValues>({
  validationSchema: commentTextValidation,
  mapPropsToValues: () => ({ text: "" }),
  handleSubmit: async (values, { props, setErrors, resetForm }) => {
    const response = await props.submit({
      postId: props.postId,
      text: values.text
    }, props.loggedUser
    );
    if (response && response.errors) {
      if (response.errors[USER_ERR_MESSAGES.LOGIN_OR_REGISTER] === USER_ERR_MESSAGES.LOGIN_OR_REGISTER) {
        loginRegisterAlert();
      } else {
        setErrors(response.errors as any);
      }
    } else {
      resetForm();
    }
  }
})(CreateCommentForm);



// WEBPACK FOOTER //
// ./src/modules/comment/create/CreateCommentView.tsx